import {
  COMMERCIAL_ACCOUNT_REGEX,
  MANHEIM_ACCOUNT_NUMBER_REGEX,
} from 'utils/pattern';
import { COMMERCIAL_ACCOUNT, MANHEIM_ACCOUNT_NUMBER } from '../../constants';

export const getOrgTypeById = (id) => {
  if (MANHEIM_ACCOUNT_NUMBER_REGEX.test(id)) {
    return MANHEIM_ACCOUNT_NUMBER;
  } else if (COMMERCIAL_ACCOUNT_REGEX.test(id)) {
    return COMMERCIAL_ACCOUNT;
  }

  return MANHEIM_ACCOUNT_NUMBER;
};
